import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_13 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={primary}
            d="M275.2,406.1h4.5c0-0.3,0-0.7,0-1c2.6-14.7,3.5-29,3.6-40c0.1-12.1,18.4-38.4,17.7-60
		c-1.9-52.7,44.3-54.8,75-50.5c16.9,2.4,33.9,2.6,50.9,0.9c30.2-2.9,75.8,0.7,74,49.6c-0.8,21.6,17.5,47.9,17.7,60
		c0.1,10.8,0.9,24.9,3.5,39.3c0,0.5,0,1.1-0.1,1.6h4.7c0.7-11.9,2.2-28.1,5.1-40.2c5.4-22.5,7.2-45.8,2.8-68.6
		c-0.9-4.9-2-10-3.2-15.2c-6.3-32.6-16.2-60.6-26.7-83.7c-1.8,23.3-6.7,42.3-6.7,42.3c0.7-3.4,1-7.8,1.2-12.7
		c0.9-32-14.4-79-33.8-104.1c-4.2-5.4-6.8-8.2-6.8-8.2c7.8,38.4-8.4,75.7-7.5,62.5c3.2-45.4-16.1-78.7-36.3-92.2
		c0,0,4.2,40.3-2.6,50.5c0-12.9-4.7-54.7-39.1-66.4c-0.2-0.1-0.3,0-0.3,0c5.2,16.7,8,71.1,0.7,72.1c-3.5,0.5-3.3-42.9-3.3-42.9
		c-29.5,23-36.3,91.3-42,82.8c-3.6-5.4,7.6-47.9,7.6-47.9c-19.1,20.2-28,60.8-32.8,74.4c-1.3,3.8-6.7,5.2-5.6,0.2
		c2.1-9.3,10.4-30.3,10.6-31.1c-16.3,15-30,46.8-40.2,107.1c-1,5.7-1.8,11.2-2.5,16.3c-2.8,20.5-1.7,41.4,4,61.2
		C272.6,374.5,274.3,393,275.2,406.1z"
          />
          <g>
            <path
              fill={primary}
              d="M274.9,401.9c1.8-0.1,3.6-0.2,5.4-0.4c2.2-13.4,2.9-26.3,3-36.4c0.1-12.1,18.4-38.4,17.7-60
			c-1.9-52.7,44.3-54.8,75-50.5c16.9,2.4,33.9,2.6,50.9,0.9c30.2-2.9,75.8,0.7,74,49.6c-0.8,21.6,17.5,47.9,17.7,60
			c0.1,8.9,0.7,19.9,2.2,31.5c0.8-0.6,1.8-1,3-1c1.5,0,2.7,0.6,3.5,1.5c0.9-10.3,2.3-22,4.5-31.2c5.4-22.5,7.2-45.8,2.8-68.6
			c-0.9-4.9-2-10-3.2-15.2c-0.6-2.9-1.2-5.7-1.8-8.5c-1.8-7.9-4.8-19.7-4.8-19.7c-4,11.9-12.6,18.6-12.6,18.6
			c1.2-29-4.3-43.9-4.3-43.9c-1.8,14.8-17.8,25.7-17.8,25.7c3.5-26-15.3-75.6-15.3-75.6c0.5,30.9-33.1,53.1-33.1,53.1
			c8.6-39.9-11.3-73.9-11.3-73.9c1.2,17.6-21.8,59.5-21.8,59.5c7-28.4-16.4-84.7-16.4-84.7c4.3,38.7-19.9,94.3-19.9,94.3
			c-10.1-12.8-16.4-65.1-16.4-65.1c-17.1,29.2-23.4,76.3-23.4,76.3c-8.2-4.8-9-28.4-9-28.4c-16.4,20-23.8,53.5-23.8,53.5
			c-9-9.2-7-19.7-7-19.7c-11.7,17.8-16.2,55.9-16.2,55.9c-3.3-6-5.8-13.6-7.7-21.2c-0.4,2.1-0.7,4.1-1.1,6.2
			c-1,5.7-1.8,11.2-2.5,16.3c-2.8,20.5-1.7,41.4,4,61.2C272.3,373.2,274,389.2,274.9,401.9z"
            />
            <path
              fill={secondary}
              d="M275,402.9h5c2.3-13.9,3.2-27.4,3.3-37.8c0.1-12.1,18.4-38.4,17.7-60c-1.9-52.7,44.3-54.8,75-50.5
			c16.9,2.4,33.9,2.6,50.9,0.9c30.2-2.9,75.8,0.7,74,49.6c-0.8,21.6,17.5,47.9,17.7,60c0.1,10.4,0.9,23.9,3.2,37.7h5.1
			c0.8-11.5,2.3-26,4.9-37c5.4-22.5,7.2-45.8,2.8-68.6c-0.9-4.9-2-10-3.2-15.2c-0.6-2.9-1.2-5.7-1.8-8.5c-1.8-7.9-4.8-19.7-4.8-19.7
			c-4,11.9-12.6,18.6-12.6,18.6c1.2-29-4.3-43.9-4.3-43.9c-1.8,14.8-17.8,25.7-17.8,25.7c3.5-26-15.3-75.6-15.3-75.6
			c0.5,30.9-33.1,53.1-33.1,53.1c8.6-39.9-11.3-73.9-11.3-73.9c1.2,17.6-21.8,59.5-21.8,59.5c7-28.4-16.4-84.7-16.4-84.7
			c4.3,38.7-19.9,94.3-19.9,94.3c-10.1-12.8-16.4-65.1-16.4-65.1c-17.1,29.2-23.4,76.3-23.4,76.3c-8.2-4.8-9-28.4-9-28.4
			c-16.4,20-23.8,53.5-23.8,53.5c-9-9.2-7-19.7-7-19.7c-11.7,17.8-16.2,55.9-16.2,55.9c-3.3-6-5.8-13.6-7.7-21.2
			c-0.4,2.1-0.7,4.1-1.1,6.2c-1,5.7-1.8,11.2-2.5,16.3c-2.8,20.5-1.7,41.4,4,61.2C272.3,373.5,274.1,390.1,275,402.9z"
            />
          </g>
        </g>
      </g>
    </>
  );
};

export default Hair_13;
